const STORAGE_KEY = 'bic_promo_popup';

/** How long the popup stays away after it was closed without being followed. */
const SNOOZE_MS = 24 * 60 * 60 * 1000;

const read = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};

    const parsed = JSON.parse(raw);
    // Earlier versions stored the dismissal time on its own.
    if (typeof parsed === 'number') return { lastShown: parsed };
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (err) {
    // Unreadable or unavailable storage: treat as never dismissed.
    return {};
  }
};

const write = (state) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (err) {
    // Ignore storage access errors - the popup simply reappears next visit.
  }
};

/**
 * Closing the popup quiets the surface for a day, counted per user rather than per campaign, so
 * coming back to the calculators page is not met with the next ad in the feed.
 */
export const isPopupSnoozed = (now = Date.now()) => {
  const { lastShown } = read();
  return typeof lastShown === 'number' && now - lastShown < SNOOZE_MS;
};

/** An ad the user has already followed has made its case and is not put in front of them again. */
export const hasActedOnAd = (adKey) => read().actedOn?.includes(adKey) ?? false;

/** 'Maybe later', the close button, the mask, Escape: not now, so ask again tomorrow. */
export const rememberSnooze = (now = Date.now()) => {
  write({ ...read(), lastShown: now });
};

/** The ad was followed, so it is retired - and the surface still rests for the usual day. */
export const rememberActedOn = (adKey, now = Date.now()) => {
  const state = read();
  const actedOn = state.actedOn ?? [];

  write({
    ...state,
    lastShown: now,
    actedOn: actedOn.includes(adKey) ? actedOn : [...actedOn, adKey],
  });
};
